// Path: ./src/app/pages/SavedProductDealTab/index.tsx
import { useContext, useEffect, useState } from "react";
import { adminApiService } from "../../../utils/api";
import { useNavigate } from "react-router-dom";
import { CustomPagination } from "../../components/Pagination";
import { GoFlyerAdminContext } from "../../../contextApi/context";
import dayjs from "dayjs";
import { useLoading } from "../../../contextApi/LoadingContext";
import { SUPERADMIN } from "../../../utils/constant/stringConstant";
import { Wrapper, DealWrapper, Element, PaginationWrapper } from "./styled";
import { GfPromotionDto } from "@swagger/typescript-fetch-goflyer";
import { DealProductCard_v2 } from "../../components/DealProductCard/index_v2";
import { routes } from "../../../utils/constant/navigationRoutes";

const SaveProductDealTab = () => {
  const { showLoadingScreen } = useLoading();
  const navigate = useNavigate();
  const [dealsData, setDealsData] = useState<GfPromotionDto[]>([]); //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) get rid of this interface if you are working on this code. just use the dto from sdk
  const [page, setPage] = useState(1);
  const [totalDeals, setTotalDeals] = useState(0);
  const { state } = useContext(GoFlyerAdminContext);

  const [perPage, setPerPage] = useState(10);
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPage(value);
  };

  const fetchDeals = async () => {
    showLoadingScreen(true);
    let storeIds: string[] = [];

    const storesList = state.user?.stores?.map((value) => {
      return `${value.id}`;
    });

    if (
      state.user?.parsedRoles?.name != SUPERADMIN &&
      storesList &&
      storesList.length > 0
    ) {
      storeIds = storesList;
    }
    const adminDeals =
      await adminApiService.gfPromotionAdminControllerGetExpiredPromotions(
        page,
        perPage,
        storeIds,
        dayjs().format("YYYY-MM-DD"),
        dayjs().format("YYYY-MM-DD"),
      );

    setTotalDeals(adminDeals?.total ? adminDeals?.total : 0);

    setDealsData(adminDeals.results);
    showLoadingScreen(false);
  };

  const handleAddDeal = (data: GfPromotionDto) => {
    navigate(routes.createDeal.editById(data.id));
  };

  useEffect(() => {
    fetchDeals();
  }, [page]);

  useEffect(() => {
    if (page === 1) {
      fetchDeals();
    } else {
      setPage(1);
    }
  }, [perPage]);

  return (
    <Wrapper data-testid="saveproductdealtab-test-id">
      <DealWrapper>
        {dealsData.length ? (
          dealsData?.map((value) => {
            return (
              <Element key={value.id} data-testid="saveproductdealtab-test-id">
                <DealProductCard_v2
                  promotion={value}
                  showAddButton={true}
                  addButtonClick={() => {
                    handleAddDeal(value);
                  }}
                  requiredPermissionAdd={["create"]}
                  requiredPermissionGroupAdd={["deals"]}
                />
              </Element>
            );
          })
        ) : (
          <></>
        )}
      </DealWrapper>
      <PaginationWrapper>
        <CustomPagination
          page={page}
          perPage={perPage}
          handlePageChange={handlePageChange}
          setPerPage={setPerPage}
          total={totalDeals}
        />
      </PaginationWrapper>
    </Wrapper>
  );
};

export default SaveProductDealTab;
